import { InjectionToken } from '@angular/core';

export class AppConfig {
    useMock: boolean;
    production: boolean;
    theme: string;
    appURL: string;
    psicLoginUrl: string;

    // Add GuestPay specific configs as needed
    guestPayService: string;
    guestPayApiKey: string;
    encryptKeyGPP: string;
    paymentURL: string;
    paymentDetailsEncryptPath: string;
    interestedProtectionPlans: string[];

    scripts: string[];
    interceptorExeptionUrlList: string[];
    recaptchaSiteKey: string;
}

export let APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');